<template>
  <div class="" ref="container">
    <q-resize-observer @resize="onResize"/>

    <TransportTypeSwitch/>

    <div v-if="!isAuthorized || !attrs.DETAILS" class="q-mb-xs q-mt-md">

      <UiInputPhone
          v-model="userPhone"
          placeholder="Телефон"
          field-name="phone"
          :required="true"
          outlined
          :bottom-slots="true"
          dense
          :emit-valid="true"
          :readonly="isAuthorized"
      >
        <template v-slot:append="{isValid}" v-if="!isAuthorized">
          <q-btn
              label="войти"
              v-if="isValid"
              color="primary"
              flat
              dense
              :icon="ICONS.login"
              @click="onAuth"
          />
        </template>
      </UiInputPhone>
    </div>

    <div v-if="attrs.DETAILS || true" class="q-mt-md">
      <div class="с-sections">

        <template v-if="attrs.TRANSPORT_TYPE === 'courier'">
          <SectionDeliveryCourier
              code="delivery_courier"
              :key="key"
          />
        </template>
        <template v-else>
          <SectionDeliveryPickup
              code="delivery_pickup"
              :key="key"
          />
        </template>

        <SectionTime
            code="time"
            :key="key"
        />

        <SectionPayment
            code="payment"
            :key="key"
        />

        <SectionCultery
            code="cultery"
            :key="key"
        />

        <SectionComment
            code="comment"
            :key="key"
        />

        <SectionOperator
            code="operator"
            :key="key"
        />

      </div>

      <div class="q-mb-sm" v-if="false">
        <q-btn outline size="13px" class="q-px-sm" color="primary" dense label="Быстрый заказ"></q-btn>
      </div>

      <div class="q-pt-md">
        <div class="q-gutter-y-sm">
          <div class="s-font-3xs text-grey-8" v-if="benefitTypes.length > 1">
            Вам доступен один из вариантов:
          </div>
          <ScrollHorizontal
              :fader-right="true"
              :fader-left="true"
              :hover-scroll="true"
              fader-width="30px"
              class="c-scroll"
              v-if="width"
              :style="{
              width: width + 'px',
              maxWidth: width + 'px',
            }"
          >
            <div class="flex no-wrap q-gutter-sm">
              <div
                  class="col-grow"
                  v-for="item in benefitTypes"
                  :key="item.value"
              >
                <component
                    :is="variants(item.value, {
                      'prize': SectionBenefitPrize,
                      'discount': SectionBenefitDiscount,
                      'bonus': SectionBenefitBonus,
                      'coupon': SectionBenefitCoupon,
                    })"
                    :code="item.section"
                    :active="item.value === benefitType"
                    :mode="benfitsMode"
                />
              </div>
            </div>
          </ScrollHorizontal>
        </div>
      </div>
    </div>
    <div v-else class="text-weight-medium">
      Подробности заказа вы сможете согласовать с оператором
    </div>

  </div>
</template>

<script setup lang="ts">

import TransportTypeSwitch from "./ui/TransportTypeSwitch.vue";

import SectionBenefitBonus from "@/components/Shop/VOrder/ui/Section/BenefitBonus.vue";
import SectionBenefitCoupon from "@/components/Shop/VOrder/ui/Section/BenefitCoupon.vue";
import SectionBenefitDiscount from "@/components/Shop/VOrder/ui/Section/BenefitDiscount.vue";
import SectionBenefitPrize from "@/components/Shop/VOrder/ui/Section/BenefitPrize.vue";
import SectionCultery from "@/components/Shop/VOrder/ui/Section/Cultery.vue";
import SectionDeliveryCourier from "@/components/Shop/VOrder/ui/Section/DeliveryCourier.vue";
import SectionDeliveryPickup from "@/components/Shop/VOrder/ui/Section/DeliveryPickup.vue";
import SectionPayment from "@/components/Shop/VOrder/ui/Section/Payment.vue";
import SectionTime from "@/components/Shop/VOrder/ui/Section/Time.vue";
import SectionOperator from "@/components/Shop/VOrder/ui/Section/Operator.vue";

import SectionComment from "@/components/Shop/VOrder/ui/Section/Comment.vue";
import ScrollHorizontal from "@/components/Ui/ScrollHorizontal.vue";
import {useDebugComponent} from "@/core/composable/useDebugComponent";
import {variants} from "@/core/util/variants";
import {useBenefitTypes} from "@/modules/shop/composable/useBenefitTypes";
import {useVorderState} from "@/modules/shop/store/vorder-state";
import {storeToRefs} from "pinia";
import {QResizeObserverProps, useQuasar} from "quasar";
import {computed, nextTick, ref, watch} from "vue";
import {useRouter} from "vue-router";
import {useUserStore} from "@/modules/user/store/user";
import UiInputPhone from "@/components/Ui/Form/UiInputPhone.vue";
import {ICONS} from "@/assets/icons";

const $q = useQuasar()
const router = useRouter()

const vorderState = useVorderState()

const onAuth = () => {
  router.push('/auth?redirect=vorder&autostart=true')
}

// Используем новый composable для benefitTypes
const {benefitTypes} = useBenefitTypes();
const userStore = useUserStore()

const {isAuthorized, userPhone} = storeToRefs(userStore)

const {
  attrs,
  benefitType
} = storeToRefs(vorderState)

const key = computed(() => attrs.value.TRANSPORT_TYPE || 'def')

const width = ref(0)

const onResize: QResizeObserverProps['onResize'] = (size) => {
  width.value = size.width
}

const benfitsMode = computed(() => {
  return 'full'
})

const container = ref<HTMLElement | null>(null);

watch(() => $q.screen.width, async () => {
  await nextTick()
  width.value = 0
  await nextTick()
  if (container.value) {
    width.value = container.value.clientWidth
  }
})

// Debug композабл для отслеживания ререндеров
useDebugComponent('VOrderForm', {collectRenders: true});

</script>

<style scoped lang="scss">


.с-sections {
  background-color: #F8F8F8;
  border-radius: 14px;
  padding: 2px 0 0 0;
  overflow: hidden;;

  :deep() {
    .c-section:not(:last-child) {
      border-bottom: 1px solid #DDDDDD;
    }
  }
}

</style>
